// `Symbol.hasInstance` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.hasinstance
require('../internals/define-well-known-symbol')('hasInstance');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.has-instance.js
// module id = 285
// module chunks = 1